<script lang="ts">
import { computed, defineComponent, inject, PropType, ref } from "vue";
import Steps from "@/components/Steps.vue";
import { NavvItem } from "@/model/NavItem";
import Abschluss from "@/components/abschluss/Abschluss.vue";
import formatUtils from "@/businesslogic/utils/formatUtils";
import dataUtils from "@/businesslogic/utils/dataUtils";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "AbschlussBL",
  methods: { dataUtils },
  emits: ["prev-page", "next-page", "goto-page", "handle-error"],
  components: {
    Steps,
    Abschluss,
  },
  props: {
    navItems: Object as PropType<NavvItem[]>,
  },
  setup(props) {
    const piniaStore = useFormStore();
    const istSichtbar: any = inject("istSichtbar");
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");
    const { formatCurrency } = formatUtils();
    const fehler = ref({} as any);

    const artDesBauvorhabens = computed(() => {
      return piniaStore.state.gebaeudedaten.artDesBauvorhabens === "01" ? "Neubau" : "Umbausanierung";
    });

    return {
      props,
      piniaStore,
      fehler,
      wechsleSichtbarkeit,
      istSichtbar,
      formatCurrency,
      artDesBauvorhabens,
    };
  },
});
</script>

<template>
  <steps v-bind:items="navItems" :active="3" @goto-page="$emit('goto-page', $event)" />

  <abschluss
    produkt="bl"
    :zeige-versichertes-objekt="true"
    :zeige-tarif="false"
    :zeige-objekt-anschrift="true"
    :zeige-selbstbeteiligung="false"
    :obligatorische-selbstbeteiligung="250"
    :zeige-anzahl-vorschaeden="true"
    :zeige-eigentumsverhaeltnisse="true"
    @next-page="$emit('next-page', $event)"
    @goto-page="$emit('goto-page', $event)"
  >
    <template v-slot:versichertes-objekt>
      <strong>
        {{ artDesBauvorhabens }}, Bausumme
        {{ formatCurrency(piniaStore.state.gebaeudedaten.bausumme) }}
        <span v-if="dataUtils().gt(piniaStore.state.gebaeudedaten.eigenbauleistungen.betrag, 0)">
          , Eigenbauleistung:
          {{ formatCurrency(piniaStore.state.gebaeudedaten.eigenbauleistungen.betrag) }}
        </span>
        <span v-if="piniaStore.state.gebaeudedaten.photovoltaikVorhanden">
          , Photovoltaik-Anlage bis 25 kWp ist mitversichert
        </span>
      </strong>
    </template>

    <template v-slot:angaben-bestaetigen v-if="piniaStore.state.isMakler">
      Ja, der Antrag wurde gemäß meinen Angaben erstellt. Der/die Versicherungsmakler/in bestätigt stellvertretend im
      Auftrage seines Mandanten, dass mein Haus/meine Wohnung ständig bewohnt ist und dass die tariflichen
      Mindestsicherungen erfüllt sind.
    </template>
    <template v-slot:angaben-bestaetigen v-else>
      Ja, der Antrag wurde gemäß meinen Angaben erstellt. Die Baumaßnahme ist aus dem privaten Wohnungsbaubereich. Der
      gewerblich genutzte Anteil beträgt maximal 49 %. Es werden keine besonderen Gründungsmaßnahmen und keine Bauten im
      Grundwasser durchgeführt. Auf eine Beratung habe ich verzichtet und damit auf den Schadenersatzanspruch nach § 6
      Abs. 5 VVG.
    </template>
  </abschluss>
</template>

<style scoped></style>
